import { ENV } from '../config/env';
import {
  PersonalizedDemoCredentials,
  buildPersonalizedDemoCredentials,
} from '../config/demoCredentials';
import { generateUsernameFromName } from '../utils/generateUsername';

export class DemoAccessService {
  static async provision(lead: {
    name: string;
    email: string;
    phone: string;
  }): Promise<PersonalizedDemoCredentials> {
    const projectId = ENV.FIREBASE_PROJECT_ID || 'erp-mock';
    const endpoint = `https://us-central1-${projectId}.cloudfunctions.net/provisionDemoAccess`;

    try {
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(lead),
      });

      const result = await response.json().catch(() => ({}));
      if (response.ok && result.success && result.username) {
        return buildPersonalizedDemoCredentials(result.username, result.salesRepUsername);
      }

      console.warn('Demo access provisioning failed, using generated username locally:', result.error);
    } catch (error) {
      console.warn('Demo access provisioning request failed:', error);
    }

    return buildPersonalizedDemoCredentials(generateUsernameFromName(lead.name));
  }
}
